import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userLoginTime: -1
    },
    mutations: {
        userTimeout(state, newTime) {
            state.userLoginTime = newTime
        }
    },
    actions: {
    },
    modules: {
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js